// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608130404/js/" + chunkId + "." + {"44":"91fe5471","225":"96dc831d","481":"4cabf11f","486":"0f607d47","770":"192744a2"}[chunkId] + ".0.5387925809626024.chunk.js";
};